<template>
  <div class="paginator">
    <div v-if="!disabled" class="paginator">
      <!-- Previous Button -->
      <button
        class="paginator-button prev"
        @click="prevPage"
        :disabled="currentPage === 1"
      >
        <icon size="18">arrow_back</icon>Prev
      </button>

      <!-- <span>Page {{ currentPage }} of {{ totalPages }}</span> -->
      <span>Page {{ currentPage }} </span>

      <!-- Next button -->
      <button
        class="paginator-button next"
        @click="nextPage"
        :disabled="currentPage === totalPages"
      >
        Next
        <icon size="18">arrow_forward</icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalPages: Number,
    disabled: Boolean,
    currentPage: Number,
  },
  methods: {
    nextPage() {
      // if (this.currentPage < this.totalPages) {
      // this.currentPage++;
      this.$emit("change", this.currentPage + 1);
      // }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.$emit("change", this.currentPage - 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.paginator {
  display: flex;
  flex-direction: row;
  align-items: center;

  //   .page-selector {
  //     background: var(--color-primary-light);
  //     border: 0;
  //     color: var(--font-color);
  //     padding: 10px 15px;
  //     margin: 0 5px;
  //     border-radius: 5px;

  //     &.current {
  //       background: var(--color-primary);
  //       color: var(--color-secondary);
  //     }

  //     &:hover {
  //       opacity: 0.7;
  //       cursor: pointer;
  //     }
  //   }

  .paginator-button {
    display: flex;
    align-items: center;
    color: var(--color-primary);
    padding: 15px;
    background: transparent;
    border: 0;
    transition: 0.3s all ease-in-out;
    outline: none;

    i {
      pointer-events: none;
    }

    &.prev i {
      margin-right: 10px;
    }

    &.next i {
      margin-left: 10px;
    }

    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }

    &:active {
      transform: scale(0.95);
    }

    &:disabled {
      color: var(--font-color-unselected);
    }
  }

  .pagination-ellipsis {
    font-size: 1.5em;
    letter-spacing: 5px;
    padding: 0 5px;
  }
}
</style>
